export default "__VITE_ASSET__Dxq6ZMyl__"